import { Box, Typography } from '@mui/material'
import { BorderedContainer } from 'components/utility/Containers'
import { pluralizeCount } from 'shared/utils'
import { LessonEntry, UnitDefinition } from 'domains/scope-and-sequence/types'

type LessonSummaryProps = {
  assignedLessons: LessonEntry[]
  poolLessons: LessonEntry[]
  units: UnitDefinition[]
  unitOptions?: { value: number; label: string }[]
  courseToolbarItems?: React.ReactElement[]
  poolToolbarItems?: React.ReactElement[]
}

export function LessonSummary({
  assignedLessons,
  poolLessons,
  units,
  courseToolbarItems = [],
}: LessonSummaryProps) {
  const totalLessons = assignedLessons.length + poolLessons.length

  return (
    <BorderedContainer>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Lesson Summary
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {pluralizeCount('Lesson', totalLessons)} across{' '}
          {pluralizeCount('Unit', units.length)}
        </Typography>
        {courseToolbarItems.length > 0 && (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {courseToolbarItems}
          </Box>
        )}
      </Box>
    </BorderedContainer>
  )
}
